exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#body[data-v-08cd5fbb]{padding-top:30px;margin-bottom:50px}#body .container[data-v-08cd5fbb]{padding:0 30px}.rightbody[data-v-08cd5fbb]{display:inline-grid}.leftbody[data-v-08cd5fbb]{display:-webkit-inline-box}#leftbody[data-v-08cd5fbb]{padding:0 13px!important}ul.list-unstyled[data-v-08cd5fbb]{margin-bottom:0!important}@media (max-width:992px){#body .container[data-v-08cd5fbb]{padding:0 15px!important;max-width:100%!important}}@media (max-width:576px){#body .container[data-v-08cd5fbb]{padding:0 5px!important;max-width:100%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08cd5fbb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dummies/dummies.vue
// module id = 670
// module chunks = 0